// 自定义课程属性定义
export const COURSE_ATTRIBUTE = {
  NAME: 0, // 课程名
  CATAlOG: 1, // 分类
  TIME: 2, // 标准时长
  SCORE: 3, // 学分
  CONTENT_TAG: 4, // 内容标签
  SKILL_TAG: 5, // 能力标签
  DESCRIBE: 6, // 简介
  PRICE: 7, // 价格
  CUSTOM_ATTRIBUTE: 8, // 自定义属性信息
  CONTRIBUTOR: 9, // 贡献者
  AUTHOR: 10, // 作者
  LECTURER: 11, // 主讲老师
  ASSISTANT_LECTURER: 12, // 辅讲老师
  CREATOR: 13, // 上传者
  CUSTOM_RELATED: 14, // 自定义相关方信息
  UNIQUE_CODE: 15, // 课程编号
  ATTACHMENT: 16, // 附件
  VALID_DATE: 17, // 有效期
  STUDY_NUM: 18, // 学习人数
  VIEW_NUM: 19, // 浏览人数
  VIEW_COUNT: 20, // 浏览人次
  CREATE_TIME: 21, // 创建时间
  UPDATE_TIME: 22, // 更新时间
  CUSTOM_CODE: 23 // 自定课程编号
};
export const DOCUMENT_FONT_SIZE = {
  NORMAL: 0, // 正常 大于9号
  SMALL: 1, // 偏小 5号-9号
  MINI: 2, // 极小 5号以下
  LIMIT: 3 // 极限字号
};

export const ENV_FLAG = {
  PRIVATE: 0,
  PUBLIC: 1
};

export const KNG_FILE_TYPE = {
  COURSE: 'course',
  VIDEO: 'video',
  IMAGE: 'img',
  WEIKE: 'xuanyes',
  ZIP: 'zip',
  AUDIO: 'audio',
  EXCEL: 'excel',
  HTML: 'html',
  PDF: 'pdf',
  PPT: 'ppt',
  SCORM: 'scorm',
  WORD: 'word'
};
export const KNG_TYPE = {
  COURSE: 0,
  DOC: 1,
  VIDEO: 2,
  AUDIO: 3,
  WEIKE: 4,
  SCORM: 5,
  HTML: 6,
  ZIP: 7,
  NEWLINK: 8,
  EXAMINE: 89,
  PRACTICE: 90,
  EXAM: 91
};

export const GROUP_AUTH_TYPE = {
  ADMIN: 0, // 超管
  ALL: 1, // 所有人
  USER_GROUP: 2, // 用户组
  COURSE_MEMBER: 3, // 课堂成员
  COURSE_MANAGER: 4, // 课堂管理员
  DEPT: 5, // 部门
  POSITION: 6, // 岗位
  ROLE: 7, // 角色
  USER: 8// 人
};

// 课程类型转路由参数
export const FILE_TYPE_TO_ROUTE_PATH = {
  doc: 'doc',
  img: 'doc',
  excel: 'doc',
  pdf: 'doc',
  ppt: 'doc',
  word: 'doc',
  video: 'video',
  audio: 'audio',
  xuanyes: 'weike',
  scorm: 'scorm',
  html: 'html',
  newlink: 'newlink',
  zip: 'zip',
  rar: 'zip',
  EXAM: 'exam',
  course: 'course'
};
